 <template>
    <v-container class="pa-0 ma-0">
        <v-row no-gutters>
            <v-col cols="12" class="pa-0 ma-0">
                <v-row v-if="accessError.status">
                    <v-col cols="12" sm="12">
                        <v-alert type="error">
                            {{ accessError.text }}
                        </v-alert>
                    </v-col>
                </v-row>
                <v-container v-if="loader" fluid fill-height>
                    <v-row >
                        <v-col cols="12" sm="12" class="text-center">
                            <div><v-progress-circular indeterminate color="grey darken-3" :size="70" :width="7"></v-progress-circular></div>
                            <div style="padding-top: 40px;">Загрузка данных...</div>
                        </v-col>
                    </v-row>
                </v-container>
                <v-container v-if="!loader && !accessError.status" fluid class="pa-0 ma-0">
                    <!--
                    <v-sheet class="pa-1 orange darken-3 lighten-2">
                        <v-text-field height="48" v-model="search" label="Поиск по названию (от 4-х символов)" hide-details solo background-color="white" clearable clear-icon="mdi-close-circle-outline"></v-text-field>
                    </v-sheet>
                    -->
                        <v-row>
                            <v-col cols="12" v-if="searchElem">
                                <v-list>
                                    <v-subheader>Найдено {{ searchFilterCounter }} файл{{ (searchFilterCounter == 1) ? '' : (searchFilterCounter > 1 && searchFilterCounter < 5) ? 'а' : 'ов' }}:</v-subheader>
                                    <v-list-item-group color="primary">
                                        <v-list-item v-for="(item, i) in searchFilter" :key="i" @click="activateItem(i)">
                                            <v-list-item-icon>
                                                <v-icon :color="(files[item.object_type]) ? files[item.object_type].color : files.other.color">
                                                    {{ (files[item.object_type]) ? files[item.object_type].icon : files.other.icon }}
                                                </v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-subtitle class="text--primary" v-html="item.object_name"></v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>

                    <v-list dense>
                        <v-list-item v-if="currentFolder !== rootFolder" @click="toParent">
                            <v-list-item-avatar>
                                <v-icon color="info">mdi-folder-upload</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-subtitle>... Вернуться назад</v-list-item-subtitle>

                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item  style="height: 50px;" v-for="(item, index) in newTree" :key="item.id" @click="(item.mimeType == 'application/vnd.google-apps.folder') ? clickFolder(item.id) : clickFile(index)">
                            <v-list-item-avatar>
                                <v-icon  v-if="item.mimeType == 'application/vnd.google-apps.folder'">mdi-folder</v-icon>
                                <v-icon v-else :color="(files[item.mimeType]) ? files[item.mimeType].color : files.other.color">
                                    {{ (files[item.mimeType]) ? files[item.mimeType].icon : files.other.icon }}
                                </v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-subtitle v-text="item.name"></v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-container>

                <v-dialog v-model="dialog2" v-if="selectedSearch">
                    <v-card>
                        <v-card-title class="title grey--text text--darken-2 text-center"><v-icon :color="(files[selectedSearch.mimeType]) ? files[selectedSearch.mimeType].color : files.other.color">
                            {{ (files[selectedSearch.mimeType]) ? files[selectedSearch.mimeType].icon : files.other.icon }}
                        </v-icon>&nbsp;{{ selectedSearch.name }}</v-card-title>
                        <v-card-text>
                            <div style="display: none;">{{ selectedSearch.id }}</div>
                            <v-alert v-if="dialogAlert" :type="dialogAlertType">
                                {{ dialogAlert }}
                            </v-alert>
                            <div ref="text" style="opacity: 0; height: 0;">{{ linkText }}</div>
                            <v-row>
                                <v-col cols="12" class="text-center" v-if="!ios"><v-btn color="orange darken-3" text :href="linkText" :disabled="!fileAccess">Поделиться файлом <v-icon right dark>mdi-share</v-icon></v-btn></v-col>
                                <v-col cols="12" class="text-center" v-if="ios">
                                    <v-btn color="orange darken-3" text v-clipboard:copy="testingCode" v-clipboard:success="onCopy" v-clipboard:error="onError" :disabled="!fileAccess">Скопировать ссылку <v-icon right dark>mdi-share</v-icon></v-btn>
                                    <input type="hidden" id="testing-code" v-model="testingCode">
                                </v-col>
                                <v-col cols="12" class="text-center"><v-btn text @click="viewerModule" color="orange darken-3" :disabled="!fileAccess || msapp">Просмотр файла <v-icon right dark>mdi-file-find</v-icon></v-btn></v-col>
                                <v-col cols="12" class="text-center"><v-btn color="orange darken-3" text @click="closeDialog2" :href="fileLink2" :disabled="!fileAccess">Скачать файл <v-icon right dark>mdi-cloud-download</v-icon></v-btn></v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="register" fullscreen hide-overlay transition="dialog-bottom-transition">
                    <v-card>
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>Регистрация в библиотеке</v-toolbar-title>
                            <div class="flex-grow-1"></div>
                            <v-toolbar-items>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-card-text v-if="!registered" class="text-center">
                            <v-row>
                                <v-col cols="12"><v-text-field type="text" label="Имя" placeholder="Семен" v-model="regData.first_name"></v-text-field></v-col>
                                <v-col cols="12"><v-text-field type="text" label="Фамилия" placeholder="Петров" v-model="regData.last_name"></v-text-field></v-col>
                                <v-col cols="12"><v-text-field type="text" label="Телефон" v-mask="mask" placeholder="999-111-22-33" v-model="regData.phone"></v-text-field></v-col>
                                <v-col cols="12"><v-select :items="usertypes" v-model="regData.type" label="Я из"></v-select></v-col>
                                <v-col cols="12" v-if="regData.type === 'franch'"><v-text-field type="text" label="Адрес станции" placeholder="г. Новосибирск, ул. Мира, 67" v-model="regData.address"></v-text-field></v-col>
                                <v-col cols="12" class="text-center"><v-btn @click="registerMe" :disabled="validateRegister" color="success">Зарегистрироваться</v-btn></v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-text v-else class="text-center">
                            <v-row>
                                <v-col cols="12">&nbsp;</v-col>
                                <v-col cols="12">
                                    <h3>Вы зарегистрированы в базе данных, но вам не назначены права доступа!</h3>
                                    <p>Ожидайте пока администратор библиотеки назначит вам права!</p>
                                </v-col>
                                <v-col cols="12" class="text-center"><v-btn href="tg://resolve?domain=AnnaNizhegorodova" color="success">Написать администратору</v-btn></v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-dialog>


                <v-dialog v-model="viewDialog2" fullscreen hide-overlay transition="dialog-bottom-transition">
                    <v-card>
                        <v-toolbar dark color="primary">
                            <v-btn icon dark @click="closeViewDialog2">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>Просмотр файла</v-toolbar-title>
                            <div class="flex-grow-1"></div>
                            <v-toolbar-items>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-card-text class="text-center">
                            <v-img @load="loadPreview = false" v-if="selectedSearch && selectedSearch.mimeType.indexOf('image/') >= 0"
                                   :src="fileLinkReal(selectedSearch)" contain style="min-height: 200px; min-width: 300px;"
                                   class="grey lighten-2">
                                <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular indeterminate color="blue darken-3"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>

                            <div class="video" v-else-if="selectedSearch && selectedSearch.mimeType.indexOf('video/') >= 0">
                                <video @canplay="updatePaused" @playing="updatePaused" @pause="updatePaused" id="videoModule" @load="loadPreview = false" style="max-height: 80vh;" controls :src="fileLinkReal(selectedSearch)">
                                    К сожалению ваш браузер не поддерживает наш плеер. <a :href="fileLinkReal(selectedSearch)">Скачайте файл</a> и смотрите с вашего устройства!
                                </video>
                            </div>


                            <v-container v-else fluid fill-height>
                                <v-row>
                                    <v-col cols="12" class="text-center">
                                        <h1 class="title">К сожалению просмотр этого документа не доступен. Вы можете его скачать.</h1>
                                        <span class="subtitle-1">Просмотреть можно pdf, видео и растровые изображения.</span>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-dialog>


            </v-col>
        </v-row>
    </v-container>
</template>
<script>
  import moment from 'moment'
  import tz from 'moment-timezone'
  import Fingerprint2 from 'fingerprintjs2'
  import { mask } from 'vue-the-mask'

  export default {
    directives: {
      mask,
    },
    data: () => ({
      folderRouter: ['1KQQJ6uFQPj5r4-7MiKzvjr-YfPYXldye'],
      parentFolder: '1KQQJ6uFQPj5r4-7MiKzvjr-YfPYXldye',
      usertypes: [
        {
          value: 'uk',
          text: 'Управляющей компании'
        },
        {
          value: 'franch',
          text: 'СТО F!TService'
        },
      ],
      userAgent: null,
      mask: '###-###-##-##',
      register: false,
      registered: false,
      regData: {
        telegram_id: null,
        first_name: null,
        last_name: null,
        phone: null,
        type: null,
        address: null,
      },
      viewDialog: false,
      viewDialog2: false,
      fileAccess: false,
      dialog2: false,
      accessAuthDate: null,
      accessCurrentMoment: null,
      accessUnixMoment: null,
      preSearch: [],
      selectedSearch: false,
      dialogAlert: null,
      searchFilterCounter: 0,
      dialogAlertType: 'info',
      dialog: false,
      open: ['1BbIaUZKN9lnDJWLDKQDLFGflRNet0Scd'],
      search: null,
      avatar: null,
      users: [],
      childs: {},
      videoElement: null,
      paused: null,
      accessError: {
        status: false,
        text: null
      },
      loader: true,
      loadPreview: true,
      access: false,
      currentFolder: '1KQQJ6uFQPj5r4-7MiKzvjr-YfPYXldye',
      rootFolder: '1KQQJ6uFQPj5r4-7MiKzvjr-YfPYXldye',
      lastParent: null,
      expireDate: moment().unix(),
      fingerprint: null,
      urlParams: null,
      compared: false,
      user: false,
      api: 'https://sbotapi.fitauto.ru/',
      structure: [],
      files: {
        'application/pdf': {
          color: 'red darken-2',
          icon: 'mdi-file-pdf'
        },
        'text/plain': {
          color: 'blue darken-1',
          icon: 'mdi-file-document-box-outline'
        },

        'application/epub+zip': {
          color: 'red darken-2',
          icon: 'mdi-book-open-variant'
        },
        'image/x.djvu': {
          color: 'red darken-2',
          icon: 'mdi-book-open-variant',
        },

        'application/msword': {
          color: 'blue darken-1',
          icon: 'mdi-file-word',
        },
        'text/rtf': {
          color: 'blue darken-1',
          icon: 'mdi-file-word',
        },
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
          color: 'blue darken-1',
          icon: 'mdi-file-word',
        },
        'application/vnd.google-apps.document': {
          color: 'blue darken-1',
          icon: 'mdi-file-word',
        },

        'video/mp4': {
          color: 'pink darken-3',
          icon: 'mdi-file-video-outline',
        },
        'video/x-ms-wmv': {
          color: 'pink darken-3',
          icon: 'mdi-file-video-outline',
        },
        'video/mpeg': {
          color: 'pink darken-3',
          icon: 'mdi-file-video-outline',
        },
        'video/quicktime': {
          color: 'pink darken-3',
          icon: 'mdi-file-video-outline',
        },

        'audio/mp3': {
          color: 'deep-purple darken-1',
          icon: 'mdi-file-music-outline',
        },
        'audio/wav': {
          color: 'deep-purple darken-1',
          icon: 'mdi-file-music-outline',
        },

        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
          color: 'green darken-2',
          icon: 'mdi-file-excel',
        },
        'application/vnd.ms-excel': {
          color: 'green darken-2',
          icon: 'mdi-file-excel',
        },
        'application/vnd.google-apps.spreadsheet': {
          color: 'green darken-2',
          icon: 'mdi-file-excel',
        },
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
          color: 'green darken-2',
          icon: 'mdi-file-excel',
        },
        'application/vnd.ms-excel.sheet.macroenabled.12': {
          color: 'green darken-2',
          icon: 'mdi-file-excel',
        },

        "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
          color: 'orange darken-2',
          icon: 'mdi-file-powerpoint',
        },


        "application/vnd.ms-powerpoint": {
          color: 'orange darken-2',
          icon: 'mdi-file-powerpoint',
        },
        "application/vnd.openxmlformats-officedocument.presentationml.slideshow": {
          color: 'orange darken-2',
          icon: 'mdi-file-powerpoint',
        },

        'image/x-coreldraw': {
          color: 'green darken-3',
          icon: 'mdi-draw',
        },
        'image/jpeg': {
          color: 'amber darken-1',
          icon: 'mdi-file-image-outline',
        },
        'image/tiff': {
          color: 'amber darken-1',
          icon: 'mdi-file-image-outline',
        },
        'image/heif': {
          color: 'amber darken-1',
          icon: 'mdi-file-image-outline',
        },
        'image/png': {
          color: 'amber darken-1',
          icon: 'mdi-file-image-outline',
        },

        'application/x-rar': {
          color: 'brown darken-1',
          icon: 'mdi-folder-zip-outline',
        },
        'application/zip': {
          color: 'brown darken-1',
          icon: 'mdi-folder-zip-outline',
        },
        'application/rar': {
          color: 'brown darken-1',
          icon: 'mdi-folder-zip-outline',
        },
        'application/vnd.android.package-archive': {
          color: 'brown darken-1',
          icon: 'mdi-folder-zip-outline',
        },

        other: {
          color: 'grey darken-3',
          icon: 'mdi-file',
        },
      },
      tree: [],
    }),
    watch: {
      dialog2: async function () {
        if(this.dialog2) {

          console.log('selected:', this.selectedSearch)

          try {
            const r = await this.$http.get(`${this.api}v3/gdrive/fileaccess?telegram_id=${this.$route.query.id}&object_id=${this.selectedSearch.id}`)
            if(r.data.access === true) {
              this.fileAccess = true
            } else {
              this.dialogAlert = r.data.reason
            }
          } catch (e) {
            console.log('access error', e)
          }
        } else {
          this.fileAccess = false
          this.dialogAlert = null
          this.selectedSearch = false
        }
      },
    },
    computed: {
      msapp() {
        let errorFiles = [
          'video/quicktime',
          'vnd.ms'
        ]
        for(let type of errorFiles) {
          if(this.selectedSearch.mimeType.indexOf(type) > -1) return true
        }
        return false
      },
      ios() {
        return (this.userAgent.match(/iPad/i) || this.userAgent.match(/iPhone/i) || this.userAgent.match(/iPod/i))
      },
      validateRegister() {
        return (this.regData.type === null || this.regData.first_name === null || this.regData.last_name === null || this.regData.phone === null || this.regData.telegram_id === null)
      },
      shareLink() {
        return this.$route.query.id == '2235540743'
      },
      testingCode() {
        if(this.selectedSearch) {
          //return 'https://teleg.run/fithelperbot?start=file-' + this.selectedSearch.object_id
          return `Чтобы получить файл ${this.selectedSearch.object_name} перейдите по ссылке tg://resolve?domain=fithelperbot&start=file-${this.selectedSearch.object_id}`
        } else {
          return 'https://teleg.run/fithelperbot'
        }
      },
      copyLinkText() {
        /*let testingCodeToCopy = document.getElementById('testing-code')
        testingCodeToCopy.setAttribute('type', 'text')    // 不是 hidden 才能複製
        testingCodeToCopy.select()
        try {
          var successful = document.execCommand('copy');
          var msg = successful ? 'successful' : 'unsuccessful';
          alert('Ссылка на файл скопирована! Перешлите ее через любой мессенджер.');
        } catch (err) {
          alert('Oops, unable to copy');
        }
        /!* unselect the range *!/
        testingCodeToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()*/
      },
      linkText() {
        if(this.selectedSearch) {
          //return 'https://teleg.run/fithelperbot?start=file-' + this.selectedSearch.object_id
          return 'tg://msg?text=' + encodeURIComponent(`Чтобы получить файл ${this.selectedSearch.object_name} перейдите по ссылке tg://resolve?domain=fithelperbot&start=file-${this.selectedSearch.object_id}`)
        } else {
          return 'https://teleg.run/fithelperbot'
        }
      },
      extView () {
        const file = this.selectedSearch
        if(this.selectedSearch) {
          console.log('selected View', ( this.selectedSearch.mimeType.indexOf('image/') >= 0 || this.selectedSearch.mimeType.indexOf('video/') >= 0 || this.selectedSearch.mimeType.indexOf('application/pdf') >= 0 ))
          return ( this.selectedSearch.mimeType.indexOf('image/') >= 0 || this.selectedSearch.mimeType.indexOf('video/') >= 0 || this.selectedSearch.mimeType.indexOf('application/pdf') >= 0 )
        } else {
          return false
        }
      },
      iframeFile () {
        //return 'https://docs.google.com/gview?url=' + this.fileLinkReal(this.selectedSearch) + '&embedded=true'
        //return (this.selectedSearch) ? 'https://docs.google.com/viewer?url=' + this.fileLinkReal(this.selectedSearch) + '&embedded=true' : '#'
        return (this.selectedSearch) ? 'https://docs.google.com/viewerng/viewer?url=' + this.fileLinkReal(this.selectedSearch) + '&embedded=true' : '#'
      },
      searchFilter () {
        const search = this.search
        if(search !== null &&search !== undefined) {
          if(search.id) {
            const result = this.tree.filter(f => f.object_id == search.object_id && f.object_type !== 'application/vnd.google-apps.folder')
            this.preSearch = result
            this.searchFilterCounter = result.length
            return result
          } else {
            const result = this.tree.filter(f => f.name.toLowerCase().indexOf(search.toLowerCase()) + 1 && f.mimeType !== 'application/vnd.google-apps.folder')
            this.searchFilterCounter = result.length
            this.preSearch = result
            return result
          }
        } else {
          //ФИльтр не нужен
          this.searchFilterCounter = 0
          this.preSearch = []
          return []
        }

      },
      searchElem () {
        const search = this.search
        if(search !== null && search !== undefined) {
          if(search.length >= 4) {
            return search
          } else {
            return null
          }
        }
        return null
      },
      fileLink () {
        if(this.selectedSearch) {
            return `${this.api}v3/gdrive/viewfile/${this.selectedSearch.id}`
        } else {
          return '#'
        }
      },
      fileLink2 () {
        if(this.selectedSearch) {
          return `${this.api}v3/gdrive/viewfile/${this.selectedSearch.id}/${this.folderRouter[this.folderRouter.length - 1]}?preview=1`
        } else {
          return '#'
        }
      },
      searchNotNull () {
        return this.search !== null
      },
      newTree () {
        const folders = this.tree.filter(f => !!f.folder).sort((a, b) => (a.name > b.name) ? 1 : -1)
        const files = this.tree.filter(f => !f.folder).sort((a, b) => (a.name > b.name) ? 1 : -1)
        let data = []
        folders.forEach(f => {
          data.push(f)
        })
        files.forEach(f => {
          data.push(f)
        })
        return data
      },
      playing() { return !this.paused }
    },
    filters: {

    },
    methods: {
      registerMe: async function () {
            try {
              const r = await this.$http.post(`${this.api}v3/telegramuser/add`, this.regData)
              location.reload()
            } catch (e) {
                console.log('Reg Error!')
            }
        },
      viewerModule () {
        if(this.selectedSearch.mimeType.indexOf('image/') > -1 || this.selectedSearch.mimeType.indexOf('video/') > -1) {
          console.log('media mimeType:', this.selectedSearch.mimeType)
          this.viewDialog2 = true
        } else {
          window.open(`${this.api}v3/gdrive/viewfile/${this.selectedSearch.id}/${this.folderRouter[this.folderRouter.length - 1]}?preview=1`, '_blank')
          //window.open(`https://docs.google.com/viewerng/viewer?url=${this.api}v3/gdrive/viewfile/${this.selectedSearch.id}&embedded=true`, '_blank')
        }
      },
      updatePaused(event) {
        this.videoElement = event.target
        this.paused = event.target.paused
      },
      play() {
        this.videoElement.play()
      },
      pause() {
        this.videoElement.pause()
      },
      toParent () {
        let folder = this.folderRouter[this.folderRouter.length - 2]
        this.getFolder(folder)
      },
      clickFile (index) {
        this.selectedSearch = this.newTree[index]
        this.dialog2 = true
      },
      clickFolder (id) {
        this.getFolder(id)
      },
      selectText(element) {
        var range;
        if (document.selection) {
          // IE
          range = document.body.createTextRange();
          range.moveToElementText(element);
          range.select();
        } else if (window.getSelection) {
          range = document.createRange();
          range.selectNode(element);
          window.getSelection().removeAllRanges();
          window.getSelection().addRange(range);
        }
      },
      copyText () {
        this.selectText(this.$refs.text)
        document.execCommand("copy")
        alert('Ссылка скопирована в буфер обмена!')
      },
      activateItem (i) {
        this.selectedSearch = this.preSearch[i]
        this.dialog2 = true
      },
      onCopy: function (e) {
        alert('Ссылка для Telegram скопирована в буфер обмена! Перешлите ее кому-нибудь.')
      },
      onError: function (e) {
        alert('Не возможно скопировать ссылку!')
      },
      closeDialog2() {
        this.selectedSearch = false
        this.dialog2 = false
      },
      closeViewDialog() {
        let vid = document.getElementById('videoModule')
        if(this.videoElement !== null) {
          this.pause()
        }
        this.viewDialog = false
        this.loadPreview = true
      },
      closeViewDialog2() {
        let vid = document.getElementById('videoModule')
        if(this.videoElement !== null) {
          this.pause()
        }

        this.dialog = false
        this.dialog2 = false
        this.selectedSearch = false
        this.viewDialog2 = false
        this.loadPreview = true
      },

      closeDialog() {
        this.selectedSearch = false
        this.dialog = false
      },
      getUser: async function(userid) {
        try {
          const r = await this.$http.get(`${this.api}v3/telegramuser/get/${userid}`)
          console.log('USER:', r.data)
          return r.data[0]
        } catch (e) {
          return undefined
        }
      },
      getUrlParams: async function () {
        //this.urlParams = new URLSearchParams(window.location.search)


        if(this.$route.query.id !== null) {
          const userExist = await this.getUser(this.$route.query.id)
          if(userExist !== undefined) {
            console.log('Exist User:', userExist)
            if(userExist.group_or_position !== null) {
              await this.checkFP()
              await this.checkCrypto()
              await this.getAccess()
              this.getFolder()
            } else {
              this.register = true
              this.registered = true
            }
          } else {
            this.regData.telegram_id = this.$route.query.id
            this.regData.first_name = this.$route.query.first_name
            this.regData.last_name = this.$route.query.last_name
            this.register = true
            console.log('PLEASE REGISTER!')
          }
        } else {
          //редирект
          this.$router.push('/nonexist')
        }
      },
      async loadChilds (item = null) {

      },
      getFolder: async function (folderid) {
        try {
          this.loader = true
          let struc = []
          let addr = (folderid !== undefined) ? `?id=${folderid}` : ``
          const r = await this.$http.get(`${this.api}v3/gdrivex/structure${addr}`)
          console.log('rData', r.data)
          struc = JSON.parse(JSON.stringify(r.data))
          struc = struc.map(f => {
            f.object_name = f.name
            f.folder = (f.mimeType === 'application/vnd.google-apps.folder')
            return f
          })
          this.tree = JSON.parse(JSON.stringify(struc))

          if(folderid !== undefined) {
            if(folderid === this.folderRouter[this.folderRouter.length - 2]) {
              this.folderRouter.splice(this.folderRouter.length - 1, 1)
            } else {
              this.folderRouter.push(folderid)
            }
          } else {
            this.folderRouter = [this.rootFolder]
          }
          this.currentFolder = (folderid !== undefined) ? folderid : this.rootFolder
          this.loader = false
        } catch (e) {
          console.log(e)
          return []
        }
      },
      fileLinkReal (file) {

        if(file) {
          return `${this.api}v3/gdrive/viewfile/${file.id}/${this.folderRouter[this.folderRouter.length - 1]}`
        } else {
          return '#'
        }
      },
      getAccess: async function () {
        try {

          const string = `${this.api}v3/access/drive?telegram_id=${this.$route.query.id}&auth_date=${this.$route.query.auth_date}&fp=${this.fingerprint}&sample=ok`
          const r = await this.$http.get(string)
          if(r.data.access === false) {
            this.loader = false
            this.accessError.status = true
            this.accessError.text = r.data.reason
          } else {
            let diff = moment(this.$route.query.auth_date, 'X').add(30, 'minutes').diff(moment(), 'seconds')
            if(diff > 0) {
              this.loader = false
              this.access = true
            } else {
              this.loader = false
              this.accessError.status = true
              this.accessError.text = 'Время жизни токена авторизации вышло. Вернитесь в Телеграм и снова нажмите кнопку "В библиотеку"'
            }
          }

        } catch (e) {
          console.log(e)
          this.expireDate = moment().unix()
        }
      },
      checkCrypto: async function () {


        try {
          const r = await this.$http.post(`${this.api}v3/crypto/fithelper`, {
            id: this.$route.query.id,
            first_name: this.$route.query.first_name,
            last_name: this.$route.query.last_name,
            username: this.$route.query.username,
            photo_url: this.$route.query.photo_url,
            auth_date: this.$route.query.auth_date,
            hash: this.$route.query.hash,
          })
          this.compared = r.data.compareString === this.$route.query.hash

        } catch (e) {
          console.log('Hash checking error!')
        }

      },
      checkFP: async function () {

        function x() {
          let promise = new Promise(function(resolve, reject) {
            if (window.requestIdleCallback) {
              requestIdleCallback(function () {
                Fingerprint2.get(function (components) {
                  const values = components.map(component => component.value )
                  let hash = Fingerprint2.x64hash128(values.join(''), 31)
                  resolve(hash)
                })
              })
            } else {
              window.setTimeout(function () {
                Fingerprint2.get(function (components) {
                  const values = components.map(component => component.value )
                  let hash = Fingerprint2.x64hash128(values.join(''), 31)
                  resolve(hash)
                })
              }, 500)
            }
          });
          return promise
        }
        this.fingerprint = await x()
      }
    },
     mounted () {
       this.userAgent = window.navigator.userAgent
       this.getUrlParams()

      //window.history.pushState({}, document.title, "/" + "drive")
    },
  }
</script>
<style>
    .v-list-item__content {
        max-width: 60vw !important;
    }
    .video {
        margin-top: 10px;
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 56.25%;
    }
    .video video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        hegiht: 100%;
    }
</style>
